import { AppBrand } from './brand.model';

export const APP_BRAND: AppBrand = {
  organisationName: "Dingley's Promise",
  productName: "Dingley's Promise Assessment Platform",
  shortProductName: 'Dingley Assessment',
  logoPath: 'images/dingley-logo.png',
  markPath: 'images/dingley-logo.png',
  homeAriaLabel: "Dingley's Promise – go to dashboard",
  copyright: "© 2026 Dingley's Promise. All rights reserved.",
  isDemo: false,
  dataNotice: '',
};

export function pageTitle(page: string): string {
  return `${page} — ${APP_BRAND.shortProductName}`;
}
